module.exports = __webpack_public_path__ + "static/media/users.3eecb4b4.svg";